import React from "react";
import "./AgentCapabilities.css";

// Home page: what an Aivio agent does beyond answering a question, each with a short example.
const CAPABILITIES = [
  {
    key: "understand", title: "Understands the goal",
    text: "Takes a request in plain language and works out what is needed, what is missing and which systems hold the answer.",
    example: "“Find out why INV-2048 hasn’t been paid.”",
    icon: <path d="M4 5h16v11H8l-4 4zM8 9h8M8 12h5" />,
  },
  {
    key: "reason", title: "Reasons and plans",
    text: "Breaks the work into steps, decides which agent and tool handles each one, and adjusts the plan when something changes.",
    example: "Match PO → check receipt → compare price → flag the gap",
    icon: <><circle cx="6" cy="6" r="2.5" /><circle cx="18" cy="12" r="2.5" /><circle cx="6" cy="18" r="2.5" /><path d="M8.5 6.5 15.6 11M8.5 17.5l7.1-4.5" /></>,
  },
  {
    key: "act", title: "Acts on your behalf",
    text: "Updates records, drafts replies, raises tickets and moves work forward in the business systems you connect.",
    example: "Ticket created in ServiceNow · CRM record updated",
    icon: <path d="M13 3 5 14h6l-1 7 8-11h-6z" />,
  },
  {
    key: "approve", title: "Checks in before critical steps",
    text: "Pauses for a person before payments, customer messages or record changes. You decide which steps need approval.",
    example: "“Price is 4% over tolerance. Hold for review?”",
    icon: <><path d="M12 3 4 6v6c0 4.5 3.4 8.2 8 9 4.6-.8 8-4.5 8-9V6z" /><path d="m9 12 2 2 4-4" /></>,
  },
  {
    key: "context", title: "Keeps the context",
    text: "Carries details from one step and one conversation to the next, so people don’t have to repeat themselves.",
    example: "“What about last quarter?” just works",
    icon: <><path d="M12 8v4l3 2" /><path d="M3.5 12a8.5 8.5 0 1 0 2.5-6M3 4v4h4" /></>,
  },
  {
    key: "explain", title: "Shows its work",
    text: "Answers link to their sources and actions are recorded, so you can see what was done, when and why.",
    example: "Step log · sources · who approved",
    icon: <><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5M9 13h6M9 17h4" /></>,
  },
];

const PRINCIPLES = ["Works only within the permissions you grant", "Hands over to a person when it isn’t sure", "Available around the clock"];

function AgentCapabilities() {
  return (
    <section className="agent-caps-section" data-reveal>
      <div className="container">
        <div className="agent-caps-heading">
          <div><div className="eyebrow section-eyebrow">What Aivio’s agents do</div><h2>They think it through, do the work <span>and check in with you.</span></h2></div>
          <p>An AI agent does more than answer. Aivio’s agents understand what you need, plan the steps, act in your systems on your behalf and pause for your approval where it matters.</p>
        </div>
        <div className="agent-caps-grid">
          {CAPABILITIES.map((item, index) => (
            <article className={`agent-cap is-${item.key}`} key={item.key}>
              <div className="agent-cap-top">
                <span className="agent-cap-icon" aria-hidden="true"><svg viewBox="0 0 24 24">{item.icon}</svg></span>
                <span className="agent-cap-n">{String(index + 1).padStart(2, "0")}</span>
              </div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
              <div className="agent-cap-example"><span aria-hidden="true">e.g.</span>{item.example}</div>
            </article>
          ))}
        </div>
        <ul className="agent-caps-principles">
          {PRINCIPLES.map((item) => <li key={item}><span aria-hidden="true">✓</span>{item}</li>)}
        </ul>
      </div>
    </section>
  );
}

export default AgentCapabilities;
